// Отходобразователи
export const garbageOffline = {
  garbageTable: function (routeName, year, operationType) {
    return `garbage-${routeName}-${year}-${operationType}`
  },
  medicalTable: function (routeName, year, operationType) {
    return `medical-${routeName}-${year}-${operationType}`
  },
  operatorTable: function (routeName) {
    return `operator-${routeName}`
  },
  operatorMedicTable: function (routeName) {
    return `operator-medic-${routeName}`
  },
  houseTable: function (routeName) {
    return `houseTable-${routeName}`
  }
}

// Отходобразователи - биллинг
export const wasteGeneratorsOffline = {
  bankBooks: () => {
    return `bankBooks`
  },
  bankBooksNormatives: () => {
    return `bankBooksNormatives`
  },
  bankBooksIndivduals: () => {
    return `bankBooksIndivduals`
  }
}

// банк технологий
export const cadastrOffline = {
  techGarbageOperationTable: function (routeName, operationType) {
    return `${routeName}-${operationType}`
  }
}

export const map = {
  threadsGarbage: function () {
    return `threadsGarbage`
  }
}

export const tkoOffline = {
  objectsTable: function (routeName) {
    return `objects-${routeName}`
  },
  operatorGarbageTable: function (routeName, year, operationType) {
    return `garbage-${routeName}-${year}-${operationType}`
  },
  objectTechTable: function (routeName) {
    return `objectTechTable-${routeName}`
  },
  objectGarbageTable: function (routeName, year, operationType) {
    return `garbage-${routeName}-${year}-${operationType}`
  },
  operatorTransportTable: function (routeName) {
    return `operatorTransportTable-${routeName}`
  },
  operatorTransportMaintenanceTable: function (routeName) {
    return `operatorTransportMaintenanceTable-${routeName}`
  }
}

export const coreOffline = {
  documents: function (routeName) {
    return `documents-${routeName}`
  }
}

export const msnOffline = {
  tkoContainersTable: function (routeName) {
    return `tkoContainersTable-${routeName}`
  },
  separateContainersTable: function (routeName) {
    return `separateContainersTable-${routeName}`
  },
  garbageHouseContainerTable: function (routeName, type) {
    return `garbageHouseContainerTable-${routeName}-${type}`
  },
  garbageTable: function (routeName, year, operationType) {
    return `garbageTable-${routeName}-${year}-${operationType}`
  },
  serviceTable: function (routeName) {
    return `serviceTable-${routeName}`
  }
}

export const waybillOffline = {
  taskTable: function (routeName) {
    return `taskTable-${routeName}`
  },
  outageTable: function (routeName) {
    return `outageTable-${routeName}`
  },
  paymentTable: function (routeName) {
    return `paymentTable-${routeName}`
  },
  reportTasksTable: function (routeName) {
    return `reportTasksTable-${routeName}`
  },
  reportRoutesTable: function (routeName) {
    return `reportRoutesTable-${routeName}`
  }
}

export const calculationOffline = {
  tariffTable: function (routeName) {
    return `tariffTable-${routeName}`
  },
  transportCostsTable: function (routeName) {
    return `transportCostsTable-${routeName}`
  },
  grossRevenueTable: function (routeName) {
    return `grossRevenueTable-${routeName}`
  },
  tariffsConsiderSentTable: function (routeName) {
    return `tariffsConsiderSentTable-${routeName}`
  }
}

export const sourcesWasteOffline = {
  garbagesTable: function (routeName, operationType) {
    return `garbagesTable-${routeName}-${operationType}`
  },
  msnsTable: function (routeName) {
    return `msnsTable-${routeName}`
  },
  garbageTable: function (routeName, year, operationType) {
    return `garbageTable-${routeName}-${year}-${operationType}`
  },
  operatorTable: function (routeName) {
    return `operatorTable-${routeName}`
  }
}

export const individualsOffline = {
  holidaysAccountsTable: (routeName) => `holidaysAccountsTable-${routeName}`
}

export const billingOffline = {
  branchTariffsTable: (routeName) => `branchTariffsTable-${routeName}`,
  branchNormativesTable: (routeName) => `branchTariffsTable-${routeName}`
}

export const atuOffline = {
  atuObjectOperationTable: function (routeName, year, operationType) {
    return `garbage-${routeName}-${year}-${operationType}`
  }
}

export const apoTariffOffline = {
  tariff: () => {
    return `tariff`
  }
}
